module.exports = __webpack_public_path__ + "img/logo_semen_indonesia.d6464e1a.png";